import './PageHeader.sass';

export interface PageHeaderProps {
  title: string;
  breadcrumbs?: React.ReactNode | undefined;
  tag?: React.ReactNode | undefined;
  actions?: React.ReactNode | undefined;
  children?: React.ReactNode | undefined;
}

// FIXME: когда уедет в кит, надо удалить из шаред
function PageHeader({
  title,
  breadcrumbs = undefined,
  tag = undefined,
  actions = undefined,
  children = undefined,
}: PageHeaderProps): JSX.Element {
  return (
    <div className="PageHeader__root">

      {!!breadcrumbs && (
        <div className="PageHeader__Breadcrumbs">
          {breadcrumbs}
        </div>
      )}

      <div className="PageHeader__Inner">
        <div className="PageHeader__Content">
          <div className="PageHeader_NameContainer">
            <h1 className="PageHeader__Name">{title}</h1>
            {tag}
          </div>
          {children}
        </div>

        <div className="PageHeader__Actions">
          {actions}
        </div>
      </div>
    </div>
  );
}

export { PageHeader };
